// extracted by mini-css-extract-plugin
module.exports = {"preserveOutline":"Item_preserveOutline__1g7xQ","item":"Item_item__4Hkxp Item_preserveOutline__1g7xQ","itemSvg":"Item_itemSvg__3eVp5","itemText":"Item_itemText__2j_fa"};